const findSchoolUrl = process.env.REACT_APP_ES_FIND_SCHOOL;
export function getAllSchools() {

  const promise = new Promise((resolve, reject) => {
    const formatSchool = (item, i)=> {
        item.rank = i + 1;
        return item;
    };

    fetch(findSchoolUrl, {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      }
    })
    .then((response) => {
        if (response.ok) {
          return response.json();
        }
        return reject(response);
      }
    ).then( (response)=> {
      let hits = response.Result;
      let formatedHits = hits.map(formatSchool);
      return resolve(formatedHits);
    });

  });
  return promise;
}

export function getNearSchools(location) {
  const promise = new Promise((resolve, reject) => {

    const formatSchool = (item, i)=> {
        item.rank = i + 1;
        return item;
    };

    fetch(findSchoolUrl+"/"+location.lon+","+location.lat, {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      }
    })
      .then((response) => {
          if (response.ok) {
            return response.json();
          }
          return reject(response);
        }
    ).then( (response)=> {
      let hits = response.Result;
      let formatedHits = hits.map(formatSchool);
      return resolve(formatedHits);
    }
      
    );

  });
  return promise;
}
